import { render, staticRenderFns } from "./FacilityPricing.vue?vue&type=template&id=be555870&scoped=true"
import script from "./FacilityPricing.vue?vue&type=script&lang=js"
export * from "./FacilityPricing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be555870",
  null
  
)

export default component.exports